import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetDeclaracionJuradaCeseActividadParcialByID from "services/record/DeclaracionJuradaCeseActividadParcial/useGetDeclaracionJuradaCeseActividadParcialByID";
import useGetInfoDeclaracionJuradaCeseActividadParcial from "services/record/DeclaracionJuradaCeseActividadParcial/useGetInfoDeclaracionJuradaCeseActividadParcial";
import useGetDeclaracionJuradaCeseActividadParcialByUser from "services/record/DeclaracionJuradaCeseActividadParcial/useGetDeclaracionJuradaCeseActividadParcialByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import DeclaracionJuradaCeseActividadParcial from "./DeclaracionJuradaCeseActividadParcial";

const GridDeclaracionJuradaCeseActividadParcial = ({ expedienteId = null, origen = null }) => {

    const {
        getDeclaracionJuradaCeseActividadParcialByID,
        loadingGetDeclaracionJuradaCeseActividadParcialByID,
        statusGetDeclaracionJuradaCeseActividadParcialByID
    } = useGetDeclaracionJuradaCeseActividadParcialByID();

    const {
        getInfoDeclaracionJuradaCeseActividadParcial,
        loadingGetInfoDeclaracionJuradaCeseActividadParcial,
        statusGetInfoDeclaracionJuradaCeseActividadParcial
    } = useGetInfoDeclaracionJuradaCeseActividadParcial();

    const {
        dataGetDeclaracionJuradaCeseActividadParcialByUser,
        getDeclaracionJuradaCeseActividadParcialByUser,
        loadingGetDeclaracionJuradaCeseActividadParcialByUser,
        statusGetDeclaracionJuradaCeseActividadParcialByUser
    } = useGetDeclaracionJuradaCeseActividadParcialByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Declaración jurada cese parcial por motivos económicos, técnicos y productivos";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getDeclaracionJuradaCeseActividadParcialByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetDeclaracionJuradaCeseActividadParcialByID?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionJuradaCeseActividadParcialByID.status,
                statusText: statusGetDeclaracionJuradaCeseActividadParcialByID.statusText
            });
        } else if (statusGetInfoDeclaracionJuradaCeseActividadParcial?.status) {
            setCurrentHttp({
                status: statusGetInfoDeclaracionJuradaCeseActividadParcial.status,
                statusText: statusGetInfoDeclaracionJuradaCeseActividadParcial.statusText
            });
        } else if (statusGetDeclaracionJuradaCeseActividadParcialByUser?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionJuradaCeseActividadParcialByUser.status,
                statusText: statusGetDeclaracionJuradaCeseActividadParcialByUser.statusText
            });
        }
    }, [
        statusGetDeclaracionJuradaCeseActividadParcialByID,
        statusGetInfoDeclaracionJuradaCeseActividadParcial,
        statusGetDeclaracionJuradaCeseActividadParcialByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getDeclaracionJuradaCeseActividadParcialByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoDeclaracionJuradaCeseActividadParcial(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetDeclaracionJuradaCeseActividadParcialByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetDeclaracionJuradaCeseActividadParcialByUser]);

    const isLoading = () => {
        return (
            loadingGetDeclaracionJuradaCeseActividadParcialByID ||
            loadingGetInfoDeclaracionJuradaCeseActividadParcial ||
            (loadingGetDeclaracionJuradaCeseActividadParcialByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetDeclaracionJuradaCeseActividadParcialByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <DeclaracionJuradaCeseActividadParcial
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getDeclaracionJuradaCeseActividadParcialByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridDeclaracionJuradaCeseActividadParcial;
